import PostTemplates from '../global-search/post-templates';

const $ = jQuery.noConflict();

'use strict';
const GlobalSearch = {

	$domSearchValue: null,
	$domSearchBtn: null,
	// pages
	$domPagesTab: null,
	$domPagesCount: null,
	$domPagesBlock: null,
	// articles
	$domArticlesTab: null,
	$domArticlesCount: null,
	$domArticlesBlock: null,
	// alerts
	$domAlertsTab: null,
	$domAlertsCount: null,
	$domAlertsBlock: null,
	// restaurants
	$domRestaurantsTab: null,
	$domRestaurantsCount: null,
	$domRestaurantsBlock: null,
	// products
	$domProductsTab: null,
	$domProductsCount: null,
	$domProductsBlock: null,
	// other
	postTypes: ['page', 'cpt_article', 'cpt_kosherconnect', 'cpt_kosher_alert', 'cpt_restaurant', 'products'],
	countText: ['.js-pages-count', '.js-article-count', '.js-connects-count', '.js-alerts-count', '.js-restaurants-count', '.js-products-count'],
	timer: null,
	allowEvents: true,
	POSTS_PER_LOAD: 50,
	allPosts: {},
	loadedPosts: {},
	observers: {},
	isLoading: {},

	init: ()=> {
		if ($('.js-site-header__top-search').length === 0) return;
		GlobalSearch.initDom();
		GlobalSearch.bindEvents();
	},

	// initialize dom variables
	initDom: ()=> {
		GlobalSearch.$domSearchValue = $('.js-global-search-value');
		GlobalSearch.$domSearchBtn = $('.js-global-search-btn');
		// pages
		GlobalSearch.$domPagesTab = $('.js-pages-tab');
		GlobalSearch.$domPagesCount = $('.js-pages-count');
		GlobalSearch.$domPagesBlock = $('.js-pages-block .search_results__items--content');
		// articles
		GlobalSearch.$domArticlesTab = $('.js-articles-tab');
		GlobalSearch.$domArticlesCount = $('.js-article-count');
		GlobalSearch.$domArticlesBlock = $('.js-articles-block .search_results__items--content');
		// kosher connects
		GlobalSearch.$domConnectsTab = $('.js-connects-tab');
		GlobalSearch.$domConnectsCount = $('.js-connects-count');
		GlobalSearch.$domConnectsBlock = $('.js-connects-block .search_results__items--content');
		// alerts
		GlobalSearch.$domAlertsTab = $('.js-alerts-tab');
		GlobalSearch.$domAlertsCount = $('.js-alerts-count');
		GlobalSearch.$domAlertsBlock = $('.js-alerts-block .search_results__items--content');
		// restaurants
		GlobalSearch.$domRestaurantsTab = $('.js-restaurants-tab');
		GlobalSearch.$domRestaurantsCount = $('.js-restaurants-count');
		GlobalSearch.$domRestaurantsBlock = $('.js-restaurants-block .search_results__items--content');
		// products
		GlobalSearch.$domProductsTab = $('.js-products-tab');
		GlobalSearch.$domProductsCount = $('.js-products-count');
		GlobalSearch.$domProductsBlock = $('.js-products-block .search_results__items--content');
	},

	bindEvents: ()=>{
		GlobalSearch.$domSearchBtn.on('click', ()=> {
			if (GlobalSearch.$domSearchValue.val().trim().length >= 3) {
				GlobalSearch.callMultipleRequests();
			}
		});
		GlobalSearch.$domSearchValue.on('keypress', (event) => GlobalSearch.pressEnter(event));
	},


	renderBridge: (response) =>{
		const count = response.data.posts.length;
		switch (response.data.postType) {
			case 'page' :
				GlobalSearch.$domPagesCount.text('('+ count + ' results)');
				GlobalSearch.appendPosts(
					response.data.posts,
					GlobalSearch.$domPagesBlock,
					GlobalSearch.$domPagesTab,
					PostTemplates.renderPages
				);
				break;
			case 'cpt_article' :
				GlobalSearch.$domArticlesCount.text('('+ count + ' results)');
				if(count === 0) {
					$('.search_results__item-btn-link').addClass('disabled');
				}
				GlobalSearch.appendPosts(
					response.data.posts,
					GlobalSearch.$domArticlesBlock,
					GlobalSearch.$domArticlesTab,
					PostTemplates.renderArticles
				);
				break;
			case 'cpt_kosherconnect' :
				GlobalSearch.$domConnectsCount.text('('+ count + ' results)');
				if(count === 0) {
					$('.search_results__item-btn-link').addClass('disabled');
				}
				GlobalSearch.appendPosts(
					response.data.posts,
					GlobalSearch.$domConnectsBlock,
					GlobalSearch.$domConnectsTab,
					PostTemplates.renderArticles
				);
				break;
			case 'cpt_kosher_alert' :
				GlobalSearch.$domAlertsCount.text('('+ count + ' results)');
				if(count === 0) {
					$('.search_results__item-btn-link').addClass('disabled');
				} else {
					$('.search_results__item-btn-link').removeClass('disabled');
				}
				GlobalSearch.appendPosts(
					response.data.posts,
					GlobalSearch.$domAlertsBlock,
					GlobalSearch.$domAlertsTab,
					PostTemplates.renderAlerts
				);
				break;
			case 'cpt_restaurant' :
				GlobalSearch.$domRestaurantsCount.text('('+ count + ' results)');
				GlobalSearch.appendPosts(
					response.data.posts,
					GlobalSearch.$domRestaurantsBlock,
					GlobalSearch.$domRestaurantsTab,
					PostTemplates.renderRestaurants
				);
				break;
			case 'products' :
				GlobalSearch.$domProductsBlock.empty();
				GlobalSearch.$domProductsCount.text('('+ response.data.posts.count + ' results)');
				GlobalSearch.$domProductsBlock.append(
					PostTemplates.renderProducts(response.data.posts)
				);
				break;
			default :
				break;
		}
	},

	// append posts or no results msg
	appendPosts: (posts, element, tab, template)=> {
		element.empty();
		if (posts.length > 0) {
			for (let i = 0; i < posts.length; i++) {
				element.append(template(posts[i]));
			}
		} else {
			element.append(PostTemplates.renderNoResults());
		}
	},

	// call request for each post type
	callMultipleRequests: async() => {
		GlobalSearch.countText.forEach(selector => $(selector).text(''));

		await Promise.all(GlobalSearch.postTypes.map(type => GlobalSearch.sendRequest(type)));
	},

	// send request with post type
	sendRequest: (postType)=> {
		// show tab loader
		GlobalSearch.switchTabLoader(postType, true);
		// show block loader
		GlobalSearch.toggleBlockLoader(true);
		$.ajax({
			url: window.fwsLocalized.ajaxUrl + '?_=' + new Date().getTime(),
			type: 'POST',
			dataType: 'JSON',
			data: {
				action: 'global_search',
				postType: postType,
				searchValue: GlobalSearch.$domSearchValue.val().trim(),
			},
			success: (response) => {
				// append results
				GlobalSearch.renderBridge(response);
			},
			complete: ()=> {
				// hide tab loader
				GlobalSearch.switchTabLoader(postType, false);
				// hide block loader
				GlobalSearch.toggleBlockLoader(false);
				GlobalSearch.appendProductLink();
			}
		});
	},

	// enter event
	pressEnter: (event) => {
		const searchValue = GlobalSearch.$domSearchValue.val().trim();
		if (event.key === 'Enter' || event.keyCode === 13) {
			event.preventDefault();
			if (searchValue.length >= 3) {
				GlobalSearch.callMultipleRequests();
			}
		}
	},

	// show/hide loader
	switchTabLoader: (postType, status)=>{
		switch (postType) {
			case 'page' :
				GlobalSearch.toggleTabLoader(GlobalSearch.$domPagesTab, GlobalSearch.$domPagesBlock, status);
				break;
			case 'cpt_article' :
				GlobalSearch.toggleTabLoader(GlobalSearch.$domArticlesTab, GlobalSearch.$domArticlesBlock, status);
				break;
			case 'cpt_kosherconnect' :
				GlobalSearch.toggleTabLoader(GlobalSearch.$domConnectsTab, GlobalSearch.$domConnectsBlock, status);
				break;
			case 'cpt_kosher_alert' :
				GlobalSearch.toggleTabLoader(GlobalSearch.$domAlertsTab, GlobalSearch.$domAlertsBlock, status);
				break;
			case 'cpt_restaurant' :
				GlobalSearch.toggleTabLoader(GlobalSearch.$domRestaurantsTab, GlobalSearch.$domRestaurantsBlock, status);
				break;
			case 'products' :
				GlobalSearch.toggleTabLoader(GlobalSearch.$domProductsTab, GlobalSearch.$domProductsBlock, status);
				break;
			default :
				break;
		}
	},


	toggleTabLoader: (element, elementBlock, status)=>{
		element.toggleClass('loading-active', status);
		elementBlock.parent().toggleClass('loading-active', status);
		$('.search_popup__results').removeClass('placeholder');
	},

	toggleBlockLoader: (status)=>{
		$('.js-block-loader').toggleClass('loading-data', status);
	},

	appendProductLink: () => {
		// Clear the href attribute of the global link
		$('.js-product-link-global').html('');
		// Get the href attribute value of the product link
		const resultsLink = $('.js-product-link').attr('href');
		// Remove any existing message
		// Check if there is a valid URL
		if (resultsLink) {
			// Set the href attribute of the global link
			$('.js-product-link-global').html(`If you are looking for a kosher product,&#160;<a href='${resultsLink}'>click here.</a>`);
		} else {
			$('.js-product-link-global').text('There are no products available under this name.');
		}
	}
};

export default GlobalSearch;
